import React, { useEffect, useRef, useState } from "react";

import { Button, Chip, Stack, TextField, Typography } from "@mui/material";
import { SelectAutocomplete } from "components/forms";
import { capitalize } from "lodash";

import { toCapitalizeList } from "./Filters";

interface Props {
  incomingValue?: string[];
  options?: string[];
  onSubmit?: (value: string[]) => void;
  onCancel?: () => void;
  onClose?: () => void;
}

export const FilterPicker: React.FC<Props> = ({ incomingValue = [], options = [], onSubmit, onCancel, onClose }) => {
  const [state, setState] = useState<string[]>(incomingValue);

  const inputRef: React.MutableRefObject<HTMLInputElement | null> = useRef(null);

  const handleSubmit = () => {
    onSubmit?.(state);
    onClose?.();
  };

  const delayedFocus = () => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 250);
  };

  useEffect(() => {
    delayedFocus();
  }, []);

  return (
    <Stack sx={{ padding: "15px" }} justifyContent="flex-start" alignItems="stretch" gap="30px" maxWidth="500px">
      <Stack
        sx={{ borderBottom: "1px solid #dae0e2", pb: "5px" }}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography sx={{ fontSize: "15px" }}>Add Filter</Typography>
        <Stack flexDirection="row">
          <Button sx={{ color: "#26A6AE" }} variant="text" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            sx={{ color: "#26A6AE", ":disabled": { backgroundColor: "#FFF", color: "#bac7ce" } }}
            variant="text"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Stack>
      </Stack>
      <SelectAutocomplete<string, true>
        multiple
        disableCloseOnSelect
        selectAll
        limitTags={1}
        openOnFocus
        options={options}
        renderInput={(params) => <TextField {...params} sx={{ width: "300px" }} label="Filters" inputRef={inputRef} />}
        renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option) => (
          <li {...props} key={option}>
            {toCapitalizeList?.includes(option) ? capitalize(option).replace(/_/g, " ") : option}
          </li>
        )}
        renderTags={(tagValue, getTagProps) => {
          return (
            <div style={{ maxHeight: "160px", overflowY: "auto", overflowX: "hidden" }}>
              {tagValue.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={index}
                  label={toCapitalizeList?.includes(option) ? capitalize(option).replace(/_/g, " ") : option}
                />
              ))}
            </div>
          );
        }}
        sx={{ maxWidth: "300px", maxHeight: "200px" }}
        defaultValue={state}
        onChange={(value) => setState(value)}
      />
    </Stack>
  );
};
